// eslint-disable-next-line vue/multi-word-component-names
<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import HeaderNav from "@/components/headerNav.vue";
import FootNav from "@/components/footNav.vue";
import {getBannerApi ,getNewsArticleTypeApi} from "@/api";
const bannerList = ref([
]),list = ref([]) ,total = ref(0)

function  getBanner (){
  getBannerApi({type:8}).then(res => {
    bannerList.value = res.data
  })
}
function getNewsArticleType() {
  getNewsArticleTypeApi({pageNo:1, pageSize:10,type:8}).then(res => {
   list.value = res.data.list
    total.value = res.data.total
  })
}
const downloadFile = (fileUrl) => {
  if (!fileUrl ) return

  // 创建一个隐藏的 <a> 标签
  const link = document.createElement('a')
  link.href = fileUrl
  link.setAttribute('download', '') // 浏览器会尝试使用 URL 中的文件名
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
getNewsArticleType()
getBanner()
</script>

<template>

  <div class="box">
    <HeaderNav :isCurrent="7" />
    <div>
      <!-- 轮播图 -->
      <el-carousel height="600px" autoplay>
        <el-carousel-item style="height: auto ;min-height: 600px" v-for="(item ,index) in bannerList" :key="index">
          <img :src="item.picUrl" :alt="item.title">
        </el-carousel-item>
      </el-carousel>
    </div>


    <!--主体内容 开始-->
    <div class="download">
      <!--右侧区域 开始-->
      <div id="right">
        <div class="right_title">
          <!--当前位置 开始-->
          <div id="location">
            <a href="/" target="_self">{{t('首页')}} </a> &nbsp;&gt;&gt;&nbsp;
            <a href="javascript:;">{{t('下载中心')}}</a>
          </div>
          <!--当前位置 结束-->
        </div>
        <div class="right_body">
          <ul class="textlist">
            <!--循环开始-->
            <li v-for="(item ,i) in list" :key="i" :id="item.id">
                    <span class="float_right" @click="downloadFile(item.picUrl)">
                        <a href="javascript:;" download="file" target="_blank" >
                            <span class="btn btn-tiny">{{t('下载')}}</span>
                        </a>
                    </span>
              <a href="javascript:;" :title="item.title">{{item.title}}</a>
            </li>
            <!--循环结束-->
          </ul>
          <div class="page_custom">
            <el-pagination background layout="prev, pager, next" :total="total" />
          </div>
        </div>
        <div class="right_bottom"></div>
      </div>
      <!--右侧区域 结束-->
      <div class="clear"></div>
    </div>
    <!--主体内容 结束-->

    <FootNav />
  </div>
</template>

<style scoped lang="scss">
.video-details {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;

  h1 {
    color: #333;
    margin-bottom: 20px;
  }

  .video-container {
    margin-top: 20px;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 8px;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>